// extracted by mini-css-extract-plugin
module.exports = {"styling":"profile_styling__3QSJ8"};